import React from "react";

export default function AccountLocked() {

    return (<div>
        <p className="zeroBottom"><strong>Uh oh! </strong>Your account is locked.</p>
        </div>);

}